// extracted by mini-css-extract-plugin
export default {"infoblock":"infoblock_infoblock__8gvpq","content":"infoblock_content__FkC06"};